import Rails from '@rails/ujs'
Rails.start()

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './admin/base'
import '../css/admin.styl'
